import axios from 'axios'
import HTTP from './http'

export default {
    getSearchWeights: payload => axios.get(HTTP.SEARCH_WEIGHTS, { params: payload }),
    addSearchWeights: payload => axios.post(HTTP.SEARCH_WEIGHTS, payload)
}
